import React from '../helpers/react';
import classList from 'ereader-core/dist/classList.js';
import { getHookClass } from '../helpers/cssHooks.js';
import onDemandLiveRegion from '../lib/ondemandregion.js';

export default (key = '') => {
    let mainClass = classList('loader', getHookClass('Loader'));
    const liveRegionDelayed = new onDemandLiveRegion({
      level: 'polite',
      delay: 50,
      parent: '.TBSPlayer'
    });
    liveRegionDelayed.say('Loading content');
    return <div className={mainClass} key={key} aria-label={'loading'}></div>
};


// WEBPACK FOOTER //
// ./src/components/Loader.js